export { default } from './Trash'
